<template lang='pug'>
  aside.c-publicity_home
    swiper.c-publicity__swiper(:options='swiperPublicities')
      swiper-slide(v-for='(publicity, index) in publicities', :class="{'c-publicity__item' : !publicity.link}", :key='index')
        a.c-publicity__item(v-if='publicity.link', :href='publicity.link', target='_blank')
        img( style='' class='lazyload u-12/12 c-publicity__image', :src='publicity.imageUrl', :data-src='publicity.imageUrlThumb')

    
</template>

<script>
  export default {
    props: {
      publicities: Array
    },
    data () {
      return {
        swiperPublicities: {
          autoHeight: true,
          pagination: {
            el: '#publicities_pagination',
            clickable: true
          },
          autoplay: {
            delay: 10000
          },
          simulateTouch: false,
          effect: 'fade',
          loop: true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppPublicities.vue